/**
 * The op registry: every rule op by its protocol name. One import and one spread line per group file
 * (ops/<group>.ts exporting `<group>Ops`); keep the groups in alphabetical order.
 */
import type { OpRegistry } from '../registry';
import { bankOps } from './bank';
import { battleOps } from './battle';
import { progressOps, progressServerOps } from './progress';
import { shopOps } from './shop';

export const RULE_OPS = {
  ...bankOps,
  ...progressOps,
  ...shopOps,
} satisfies OpRegistry;

/** Names of the registered ops. */
export type RuleOpName = keyof typeof RULE_OPS;

/**
 * Ops the backend runs itself with server-trusted inputs (the battle outcome the validator verified, the assault
 * zone's stage and owner, the in-flight battle it keeps): never reachable through player.command, so they are not
 * part of RULE_OPS. Same shape, so executeOp(op, state, args, ctx, SERVER_RULE_OPS) runs them.
 */
export const SERVER_RULE_OPS = {
  ...battleOps,
  ...progressServerOps,
} satisfies OpRegistry;
